import axios from 'axios';
import Markdown from 'markdown-to-jsx';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AcnColorTheme } from '../../assets/css/AcnColorTheme';
import DynamicTitle from '../../component/DynamicTitle';
import TemplateComponent from '../../component/template/TemplateComponent';
import { UserInfoModel } from '../../models/UserInfoModel';
import { Service } from '../../service/ServiceApi';
import { RootState } from '../../store';
import { actions as UserAction } from '../../store/redux/UserInfoRedux';
import { NavTo } from '../../utils/AppManager';
import { Path } from '../../utils/Constant';
import { fontUnit, padGinUnit } from '../../utils/DeviceManager';

export function ConsentScreen() {
  const dispatch = useDispatch();
  const [userInfo] = useSelector((state: RootState) => [state.userInfoReducer.userInfo]);

  const [consent, setConsent] = useState(false);
  const [consentDetail, setConsentDetail] = useState('');

  const onConfirm = () => {
    if (consent && consentDetail.length > 0) {
      const newInfo: UserInfoModel = { ...userInfo, consent: consent };
      UserAction.setUserInfo(dispatch, newInfo).then(() => {
        NavTo(Path.mobile);
      });
    }
  };

  const getConsent = async () => {
    const res = await axios.get(`${Service.STRAPI}/term-and-condition`).then();
    setConsentDetail(res.data.description);
  };

  useEffect(() => {
    document.title = 'สมัครใช้งาน\u200E';
    getConsent();
  }, []);

  const nationalIdWidget = () => {
    return (
      <div style={{ overflow: 'hidden' }}>
        <div
          style={{
            overflowY: 'auto',
            paddingBottom: padGinUnit(52),
          }}
        >
          <DynamicTitle
            title={'ข้อกำหนดและเงื่อนไขการใช้บริการ Chaiyo Connect'}
            size={fontUnit(24)}
            isFull={true}
            align={'left'}
          />
          <div
            style={{
              overflowY: 'auto',
              scrollbarGutter: 'always',
              height: window.innerHeight * 0.8 - 104,
              // height: "54vh",
              // minHeight: "312px",
              backgroundColor: AcnColorTheme.white,
              marginTop: padGinUnit(24),
              padding: padGinUnit(8),
              borderRadius: 8,
            }}
            onClick={(event) => {
              if (window.innerHeight * 0.57 > event.screenY) {
                setConsent(true);
              }
            }}
            data-testid="consentDetail"
            onScroll={(event) => {
              const target = event.currentTarget;
              // if (target.scrollHeight - target.scrollTop >= target.clientHeight - 20) {
              if (target.scrollHeight - target.scrollTop - 10 <= target.clientHeight) {
                setConsent(true);
              }
            }}
          >
            <div
              style={{
                fontFamily: 'Thonburi',
                color: AcnColorTheme.black,
                textAlign: 'start',
                overflow: 'auto',
                padding: padGinUnit(4),
              }}
            >
              <Markdown
                options={{
                  overrides: {
                    li: {
                      props: {
                        style: {
                          listStylePosition: 'inside',
                        },
                      },
                    },
                    ol: {
                      props: {
                        style: {
                          padding: 0,
                        },
                      },
                    },
                  },
                }}
              >
                {consentDetail ? consentDetail : 'loading...'}
              </Markdown>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <TemplateComponent
      content={nationalIdWidget()}
      onNext={onConfirm}
      isCanNext={consent && consentDetail.length > 0}
      nextText={'ยินยอม'}
    />
  );
}
